import styled from 'styled-components';
import { Link } from 'react-router-dom'

interface NavItemProps {
  icon: string;
  label?: string;
  onClick: () => void;
  to?: string;
}

const NavItemContainer = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  position: absolute;
  right: 18px;
  img {
    width: 18px;
  }

  span {
    display: inline-block;
  }
`;

function NavItem({ icon, label, onClick, to }: NavItemProps) {
  if (to) {
    return (
      <Link to={to}>
        <NavItemContainer onClick={onClick}>
          <img src={icon} alt={label} />
          {label && <span>{label}</span>}
        </NavItemContainer>
      </Link>
    );
  }
  
  return (
    <NavItemContainer onClick={onClick}>
      <img src={icon} alt={label} /> {/* 프로퍼티로 전달받은 icon 이미지를 표시하고, alt 속성을 label로 설정합니다. */}
      {label && <span>{label}</span>} {/* label이 존재하면 span 요소로 렌더링합니다. */}
    </NavItemContainer>
  );
}

export default NavItem;